export default function hasValidRedirect(redirectUrl = '') {
  const isHTTP = redirectUrl.startsWith('http://');
  const isHTTPS = redirectUrl.startsWith('https://');
  return isHTTP || isHTTPS;
}
